import { createContext } from 'react';
import {
    QUERY_KEYS_SECURITY,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../../Seguranca/Common/Filters/hooks/useSecurityFiltersContext';

export const OcurrencesChartsDataContext = createContext();

const OcurrencesChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: filters.year?.value || '',
            month: filters.month?.value ? String(Number(filters.month?.value)) : "",
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.ART173_ECA_OCURRENCES,
            url: 'governanceroom/securitydashboard/productivityData/art173eca/ocurrences'
        },
        filterParams
    );

    const chartData = {
              ocurrencesAnual: data?.anualEvolution || [],
              ocurrencesMonth: data?.monthEvolution || []
          }

    return (
        <OcurrencesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </OcurrencesChartsDataContext.Provider>
    );
};

export default OcurrencesChartsDataProvider;
